import { useQuery } from "@tanstack/react-query";

import { contentGet } from "@/api_client";
import { contentQueryKey } from "@/hooks/api/content/contentQueryKey";

export const useContent = (
  enabled: boolean = true,
  language: string | null = null,
) => {
  return useQuery({
    enabled,
    queryKey: contentQueryKey,
    queryFn: () => contentGet({ path: { language } }).then((res) => res.data),
    staleTime: Infinity,
    placeholderData: (prev) => prev,
  });
};
